import {
  FirestoreDataConverter,
  QueryDocumentSnapshot,
  SnapshotOptions,
} from '@angular/fire/firestore';
import {
  FcmTokenAngularAppModel,
  FcmTokenAngularAppSchema,
  FcmTokenAngularDbModel,
  FcmTokenAngularDbSchema,
} from '@padspin/models-angular';

export class FcmTokenAngularConverter implements FirestoreDataConverter<
  FcmTokenAngularAppModel,
  FcmTokenAngularDbModel
> {
  fromFirestore(
    snapshot: QueryDocumentSnapshot<FcmTokenAngularDbModel>,
    options?: SnapshotOptions,
  ): FcmTokenAngularAppModel {
    const parsedDB = FcmTokenAngularDbSchema.parse(snapshot.data(options));
    return FcmTokenAngularAppSchema.parse(parsedDB);
  }

  toFirestore(o: FcmTokenAngularAppModel): FcmTokenAngularDbModel;
  toFirestore(
    o: Partial<FcmTokenAngularAppModel>,
    options: { merge: true },
  ): Partial<FcmTokenAngularDbModel>;
  toFirestore(
    o: FcmTokenAngularAppModel | Partial<FcmTokenAngularAppModel>,
    options?: { merge: boolean },
  ): FcmTokenAngularDbModel | Partial<FcmTokenAngularDbModel> {
    if (options && options.merge) {
      const parsedPartialApp = FcmTokenAngularAppSchema.partial().parse(o);
      const parsedPartialDB =
        FcmTokenAngularDbSchema.partial().parse(parsedPartialApp);
      return parsedPartialDB satisfies Partial<FcmTokenAngularDbModel>;
    }
    const parsedFullApp = FcmTokenAngularAppSchema.parse(o);
    return FcmTokenAngularDbSchema.parse(parsedFullApp);
  }
}
